import React from 'react';
import usesImage from '../../assets/taasafleet.png';
import './uses.css';
//import Card from 'material-ui'

const uses = () => (
  <div className="taasa__uses section__padding" id="uses">
    <div className="taasa__uses-image">
      <img src={usesImage} alt="uses" />
    </div>
    <div className="taasa__uses-content">
      <h4>Immerse yourself in a new experience</h4>      
      <h1 className="gradient__text">The safety of your assets <br /> and employees is guaranteed. </h1>
      <p>You can work efortlessly without a worry. Your fleet is in risk-free hands.</p>
      <h4>Choose safety today</h4>
  </div>           
  </div>
);

export default uses;
